import React from 'react';
import { css } from 'linaria';
import ChildrenCategories from './ChildrenCategories';
import SiblingCategories from './SiblingCategories';
import ReadMore from '../../Theme/ReadMore';
import { Above } from '@jetshop/ui/Breakpoints';
import { theme } from '../../Theme';

const siblingCategoriesCSS = css`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.space[3]};

  overflow-y: auto;

  .navigation-items {
    display: flex;
    flex-direction: row;
    grid-gap: ${theme.space[2]};

    white-space: nowrap;
    overflow-x: auto;

    .navigation-list-item {
      a {
        width: auto;
        &.active {
          background: ${theme.colors.black};
          color: ${theme.colors.white};
        }
      }
    }
  }
`;

const childrenCategoriesCSS = css`
  width: 100%;

  ${theme.below.md} {
    margin-top: ${theme.space[2]};
  }

  h2 {
    font-size: ${theme.themeFontSizes.xl};
    margin-bottom: ${theme.space[2]};
  }

  > div {
    width: 100%;
  }

  .navigation-items {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    grid-gap: ${theme.space[1]};
    width: 100%;

    ${theme.above.md} {
      flex-direction: row;
      grid-gap: ${theme.space[2]};
    }

    .navigation-list-item {
      a {
        width: 100%;
        height: 48px;

        ${theme.above.md} {
          width: auto;
        }
        &.active {
          background: ${theme.colors.black};
          color: ${theme.colors.white};
        }
      }
    }
  }
`;

const ChildrenOrSiblings = ({ category }) => {
  const hasNoParent = category?.parent === null;
  const hasNoChild = category?.subcategories?.length > 0;

  return (
    <>
      <Above breakpoint="md">
        {matches =>
          matches ? (
            <>
              {hasNoChild && (
                <div className={siblingCategoriesCSS}>
                  <SiblingCategories category={category} />
                </div>
              )}
              {/* {!hasNoChild && (
                <div className={childrenCategoriesCSS}>
                  <SiblingCategories category={category} />
                </div>
              )} */}
              <div className={childrenCategoriesCSS}>
                <ChildrenCategories category={category} />
              </div>
            </>
          ) : (
            <>
              {!hasNoParent && hasNoChild && (
                <div className={siblingCategoriesCSS}>
                  <SiblingCategories category={category} />
                </div>
              )}
              {!hasNoChild && (
                <div className={childrenCategoriesCSS}>
                  <ReadMore condition={category.subcategories?.length > 6}>
                    <SiblingCategories category={category} />
                  </ReadMore>
                </div>
              )}

              <div className={childrenCategoriesCSS}>
                <ReadMore condition={category.subcategories?.length > 6}>
                  <ChildrenCategories category={category} />
                </ReadMore>
              </div>
            </>
          )
        }
      </Above>
    </>
  );
};

export default ChildrenOrSiblings;
